/* wf-cart-upsell-nav – pilknappar på "Populära val tillsammans" i varukorgslådan (2026-09-25).
   Visar att raden går att svepa/scrolla. Knapparna läggs in av skriptet (inte i Liquid) så att de
   följer med när Dawns cart.js ritar om lådan via Section Rendering API – en MutationObserver på
   <cart-drawer> kopplar på dem igen. Vänsterpilen döljs i början av raden, högerpilen i slutet.
   Stil: assets/wf-cart-drawer.css (.wf-cart__upsell-nav). Laddas av snippets/cart-drawer.liquid. */
(function () {
  if (window.wfUpsellNav) return;
  window.wfUpsellNav = 1;

  var LABELS = {
    sv: ['Föregående', 'Nästa'],
    en: ['Previous', 'Next'],
    fr: ['Précédent', 'Suivant'],
    es: ['Anterior', 'Siguiente'],
    de: ['Zurück', 'Weiter'],
    it: ['Precedente', 'Successivo']
  };
  var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var t = LABELS[lang] || LABELS.en;
  var PATHS = { prev: 'M12.5 4.5 7 10l5.5 5.5', next: 'M7.5 4.5 13 10l-5.5 5.5' };

  function update(section, row) {
    var max = row.scrollWidth - row.clientWidth - 2;
    section.classList.toggle('is-at-start', row.scrollLeft <= 2);
    section.classList.toggle('is-at-end', row.scrollLeft >= max);
    section.classList.toggle('is-static', max <= 0);
    var card = row.querySelector('.wf-cart__upsell-card');
    /* kortets offsetParent är sektionen (position: relative), så offsetTop är redan relativt sektionen */
    var top = card ? card.offsetTop + card.offsetHeight / 2 : row.offsetTop + row.offsetHeight / 2;
    section.style.setProperty('--wf-upsell-nav-top', top + 'px');
  }

  function step(row, dir) {
    var card = row.querySelector('.wf-cart__upsell-card');
    var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
    var width = card ? card.getBoundingClientRect().width + gap : row.clientWidth * 0.8;
    row.scrollBy({ left: dir === 'prev' ? -width : width, behavior: 'smooth' });
  }

  function setup() {
    document.querySelectorAll('.wf-cart--drawer .wf-cart__upsell').forEach(function (section) {
      var row = section.querySelector('.wf-cart__upsell-row');
      if (!row) return;
      if (!section.querySelector('.wf-cart__upsell-nav')) {
        ['prev', 'next'].forEach(function (dir, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'wf-cart__upsell-nav wf-cart__upsell-nav--' + dir;
          b.setAttribute('aria-label', t[i]);
          b.innerHTML =
            '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="' + PATHS[dir] +
            '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          b.addEventListener('click', function () {
            step(row, dir);
          });
          section.appendChild(b);
        });
        row.addEventListener('scroll', function () {
          update(section, row);
        }, { passive: true });
      }
      update(section, row);
    });
  }

  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(setup).observe(drawer, { childList: true, subtree: true });
      /* lådan är dold vid sidladdning – mät om när den öppnas (klassen active sätts av cart-drawer.js) */
      new MutationObserver(function () {
        requestAnimationFrame(setup);
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    setup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('resize', setup);
})();
